<template>
    <div class="row">
        <div class="col-md-12">

            <table class="table" v-if="status">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Last Auto-Queued</th>
                        <th>Last Synced</th>
                        <th>Manual</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(sync, syncType) in status.syncs">
                        <td>{{syncType}}</td>
                        <td>
                            <template v-if="sync.last_queued_at">{{$formatDate(sync.last_queued_at, user_date_format, 'HH:mm:ss', centre.time_zone_id)}}</template>
                            <template v-else>Never</template>
                        </td>
                        <td>
                            <template v-if="sync.last_sync_at">{{$formatDate(sync.last_sync_at, user_date_format, 'HH:mm:ss', centre.time_zone_id)}}</template>
                            <template v-else>Never</template>
                        </td>
                        <td>
                            <span v-if="sync.has_sync_ongoing" class="btn btn-light"><i class="fa fa-refresh anim-spin"></i> Syncing...</span>
                            <a v-if="!sync.has_sync_ongoing" @click="requestSyncWithConfirmForBookings(sync)"
                           :class="[sync.sync_type === 'bookings' && sync.is_not_using_booking_sync && !status.can_override_bookings_sync ? 'invisible' : 'btn btn-light']">Request</a>
                        </td>
                    </tr>
                </tbody>
            </table>

            <hr />

            <div class="card">
                <div class="card-header">
                    <h3>
                        <strong>Last requested manual syncs</strong>
                        <button @click="refreshCentreSyncStatus()" class="btn btn-xs btn-light float-end">Refresh</button>
                    </h3>
                </div>
                <div class="card-body">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Sync type</th>
                                <th>Centre</th>
                                <th>Company</th>
                                <th>Status</th>
                                <th>Created at</th>
                                <th>Started at</th>
                                <th>Completed at</th>
                            </tr>
                        </thead>
                        <tbody v-if="manualSyncs">
                            <tr v-for="sync in manualSyncs">
                                <td><span>{{sync.sync_type}}</span></td>
                                <td><span v-if="sync.centre">{{sync.centre.name}}</span></td>
                                <td><span v-if="sync.company">{{sync.company.name}}</span></td>
                                <td width="100">
                                    <div class="">
                                        <span class="text-primary" v-if="sync.status === 'processing'"><i class="fa fa-refresh anim-spin"></i> Processing</span>
                                        <span class="text-info" v-if="sync.status === 'pending'"><i class="fa fa-pause"></i> Pending</span>
                                        <span class="text-success" v-if="sync.status === 'completed'"><i class="fa fa-check"></i> OK</span>
                                        <span class="text-danger" v-if="sync.status === 'failed'"><i class="fa fa-ban"></i> Failed</span>
                                    </div>
                                </td>
                                <td><span>{{$formatDate(sync.created_at, user_date_format, 'HH:mm:ss', centre.time_zone_id)}}</span></td>
                                <td><span>{{$formatDate(sync.started_at, user_date_format, 'HH:mm:ss', centre.time_zone_id)}}</span></td>
                                <td>
                                    <div class="text-danger" v-if="sync.failed_at">{{$formatDate(sync.failed_at, user_date_format, 'HH:mm:ss', centre.time_zone_id)}}</div>
                                    <div class="text-success" v-if="sync.completed_at">{{$formatDate(sync.completed_at, user_date_format, 'HH:mm:ss', centre.time_zone_id)}}</div>
                                    <pre v-if="sync.failure">{{sync.failure}}</pre>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import Sync from '../../Services/Sync'
import Vue from "vue";
import Swal from "sweetalert2";

export default {
    computed: {
        Vue() {
            return Vue
        }
    },

        props: ['centre', 'user_date_format'],

        data: () => { return {
            status: null,
            manualSyncs: [],
        }},

        mounted: function() {
            this.refreshCentreSyncStatus();

            setInterval(() => {
                this.refreshCentreSyncStatus();
                this.$forceUpdate();
            }, 5000);
        },

        methods: {

            refreshCentreSyncStatus: function() {
                Sync.getStatus(this.centre.id).then((status) => {
                    this.status = status
                });

                this.refreshManualSyncList()
            },

            refreshManualSyncList: function() {
                Sync.getLastManualSyncs(this.centre.id).then((syncList) => {
                    this.manualSyncs = syncList
                });
            },

            requestSyncWithConfirmForBookings: function(sync) {
                if (sync.sync_type === 'bookings') {
                    Swal.fire({
                        title: 'Warning',
                        text: "This action will complete a full database synchronisation which impacts the system performance. Please, in the first instance try synching by customer booking in the ‘Companies' or 'Access’ menu.",
                        showCancelButton: true,
                        confirmButtonText: 'Continue',
                        cancelButtonText: 'Cancel',
                        reverseButtons: true,
                        buttonsStyling: false,
                        customClass: {
                            cancelButton: 'btn btn-light btn-spacer',
                            confirmButton: 'btn btn-danger',
                        }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.requestSync(sync);
                        }
                    });

                    return false;
                }

                this.requestSync(sync);
            },

            requestSync: function(sync) {
                sync.has_sync_ongoing = true;
                this.$forceUpdate();

                Sync.requestManualCentreSync(this.centre.id, sync.sync_type).then((res) => {
                    this.refreshCentreSyncStatus();
                })
            },
        }
    }
</script>
